import React from "react";
import { useDispatch } from "react-redux";


import { Button } from "components";
import {
	DocumentsTable,
	DocumentsServiceContext,
} from "components/tables/documents";
import { applicationDocumentsService } from "services";
import { uiActions } from "store";

const TIDEquipmentInstallationAttachments = ({ entityId, key }) => {
	const dispatch = useDispatch();

	const handleAddDocument = ({ addDocument }) => {
		dispatch(
			uiActions.showModal("DOCUMENT", {
				onAddDocument(document) {
					return addDocument({ entityId, document });
				},
			}),
		);
	};

	const handleDeleteDocument = ({ document, deleteDocument }) => {
		dispatch(
			uiActions.showModal("CONFIRMATION", {
				title: "Are you sure you want to delete the document?",
				onConfirm() {
					return deleteDocument({
						entityId,
						documentId: document.id,
					});
				},
			}),
		);
	};

	const handleViewDocument = ({ document, viewDocument }) => {
		return viewDocument({ entityId, documentId: document.id });
	};

	const handleDownLoadDocument = ({ document, downloadDocument }) => {
		return downloadDocument({
			entityId,
			documentId: document.id,
		});
	};

	return (
		<DocumentsServiceContext.Provider
			value={{
				key: [key, entityId],
				service: applicationDocumentsService,
			}}
		>
			<DocumentsTable
				entityId={entityId}
				AddDocumentButton={({ addDocument }) => (
					<Button
						onClick={() => handleAddDocument({ addDocument })}
						value="Add New"
					/>
				)}
				onDeleteDocument={handleDeleteDocument}
				onViewDocument={handleViewDocument}
				onDownloadDocument={handleDownLoadDocument}
			/>
		</DocumentsServiceContext.Provider>
	);
};

export default TIDEquipmentInstallationAttachments;
